import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Row } from "@faire/web--source/slate/Layout/Row";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import { FilterInfoSticky } from "@faire/retailer/components/Filters/FilterInfoSticky";
import { getSDUIFilterName } from "@faire/retailer/components/SDUI/__internal__/Filters/getSDUIFilterName";
import { ComponentLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
import { subtitleStyle } from "@faire/retailer/components/SDUI/ComponentRenderers/FilterBar/__internal__/styles.css";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
export var SDUIFilterRowRenderer = function(param) {
    var isFilterLoading = param.isFilterLoading, sectionLoggingParams = param.sectionLoggingParams, component = param.component;
    var filterBarComponent = component.filter_bar_component;
    var loggingEventParams = ComponentLoggingEventParams.build(_object_spread_props(_object_spread({}, sectionLoggingParams, component.logging_data), {
        component_id: component.id
    }));
    if (filterBarComponent === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            filterBarComponent.title ? /*#__PURE__*/ _jsx(Row, {
                align: "center",
                style: filterBarComponent.subtitle ? undefined : {
                    paddingBottom: getSpacing("1x")
                },
                children: /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                    textElement: filterBarComponent.title,
                    loggingData: loggingEventParams
                })
            }) : null,
            filterBarComponent.subtitle ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                textElement: filterBarComponent.subtitle,
                loggingData: loggingEventParams,
                className: subtitleStyle
            }) : null,
            /*#__PURE__*/ _jsx(FilterInfoSticky, {
                name: getSDUIFilterName(loggingEventParams === null || loggingEventParams === void 0 ? void 0 : loggingEventParams.view_display_page),
                isLoading: isFilterLoading,
                shouldShowSort: true,
                shouldEnableScrollToProducts: true
            })
        ]
    });
};
